import { render, staticRenderFns } from "./payment-file.view.vue?vue&type=template&id=30987b8b&scoped=true&"
import script from "./payment-file.view.vue?vue&type=script&lang=ts&"
export * from "./payment-file.view.vue?vue&type=script&lang=ts&"
import style0 from "./payment-file.view.vue?vue&type=style&index=0&id=30987b8b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30987b8b",
  null
  
)

export default component.exports